// extracted by mini-css-extract-plugin
export default {"home":"Home_home__gSLe9","home-img":"Home_home-img__1ybTQ","home-text":"Home_home-text__lSXjq"};